import { IPunchDocument } from "../../models"

export interface IPunchExceptionReviewDialogContent {
    exceptionPunchId: string
    clickedExceptionType: EExceptionReviewDialogExceptionType
    punches: IPunchDocument[]
    availableExceptionTypes: EExceptionReviewDialogExceptionType[]
    reviewedType: EExceptionReviewDialogReviewType
    closeCallback(): void
}

export enum EExceptionReviewDialogExceptionType {
    Biometric,
    Location
}

export enum EExceptionReviewDialogReviewType {
    All,
    NotReviewed,
    Reviewed,
    Rejected
}